export default "__VITE_ASSET__DdHb6xXi__"